import { RouteRecordRaw } from 'vue-router';
import { defaultMetaMessages } from '../routesSetup';
import MessageVerifyIdentityView from '../../lib/pages/MessageVerifyIdentityView.vue';
import MessageThreadView from '../../lib/pages/MessageThreadView.vue';
import MessageReplySentView from '../../lib/pages/MessageReplySentView.vue';

// Access: the message link plus a date-of-birth challenge — nothing else is asked for, and
// the endpoint also gates on link expiry and a time-based lockout after failed attempts.
// ENG-21798 replaces each EmptyView with the comms view for that step.
const messagesChildren: RouteRecordRaw[] = [
  {
    path: 'verify-identity',
    name: 'messages-verify-identity',
    component: MessageVerifyIdentityView,
    meta: {
      ...defaultMetaMessages,
      layoutPageTitle: 'Confirm your identity',
      pageTitle: 'Confirm your identity',
      backButton: false,
      // ENG-21791 a live session should not cost a second DOB entry
      skipIfMessageResolved: true,
    },
  },
  {
    path: 'message',
    name: 'messages-message',
    component: MessageThreadView,
    meta: {
      ...defaultMetaMessages,
      layoutPageTitle: 'Your message',
      pageTitle: 'Your message',
      // ENG-21791 refresh, bookmark or cleared session must return to the DOB challenge
      requiresVerifiedMessage: true,
    },
  },
  {
    // The reply form lives on the thread, under the message being answered. This route
    // stays so the V1 SMS link /m/{id}/reply keeps resolving (see canonicalPaths).
    path: 'reply',
    name: 'messages-reply',
    redirect: (to) => ({ name: 'messages-message', params: to.params, hash: '#reply' }),
  },
  {
    path: 'reply-sent',
    name: 'messages-reply-sent',
    component: MessageReplySentView,
    meta: {
      ...defaultMetaMessages,
      layoutPageTitle: null,
      pageTitle: 'Reply sent',
      panelTitle: 'Reply sent',
      backButton: false,
    },
  },
];

export default messagesChildren;
